import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';
import { JobPhasePhotoCreatableInterface } from '../interfaces/job-phase-photo-creatable.interface';
import { JobPhasePhotoDto } from './job-phase-photo.dto';

export class JobPhasePhotoCreateDto
  extends IntersectionType(
    PickType(JobPhasePhotoDto, ['fileName', 'jobPhaseId']),
    PartialType(PickType(JobPhasePhotoDto, ['metaData'])),
  )
  implements JobPhasePhotoCreatableInterface {}
